import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { capitalize } from '../../utilities/Forms.js'

class StafFulfilmentFlow extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  currentPage(type, name) {
    if (this.props[type] === name) {
      return "current"
    }
  }

  renderHelpText(schedule, coverage, view) {
    // eslint-disable-next-line
    switch (`${schedule} ${coverage} ${view}`) {
      case "template requirements ":
        return (
          <p>
            This page is to set up your Template Requirement levels, which are the necessary number of staff of each Role you need per hour. These levels will be used to highlight where you have gaps in your Staff Fulfilment. These levels will be repeated each week and will become your normal Weekly Requirement levels, but you can add exceptions for when these levels need to change for a particular day, but not permanently, in the Weekly Requirements page.
          </p>
        )

      case "weekly requirements ":
        return (
          <p>
            These are one-off exceptions for days where your Template Requirement levels need to be higher or lower. Weekly Requirement levels are used to highlight where you have underfulfilled or overfulfilled the Shifts.
          </p>
        )

      case "template shifts ":
        return (
          <>
          <p>
            These are Shifts which are repeated on a weekly basis, for each member of staff. Exceptions to the Template Shifts can be added on the Weekly Shifts steps. This page makes use of the Template Requirement levels. Red means underfulfilled, Orange means overfulfilled, and Green means perfect fulfilment.
          </p>
          <p>
            You can also set up Unassigned Templated Shifts when you know they need to happen each week, but aren't sure who will work the Shift. These will show in the chart as Yellow.
          </p>
          </>
        )

      case "weekly shifts by Role":
        return (
          <p>
            This is your main view of Staff Fulfilment and shows the combination of Weekly Requirements and Weekly Shifts. You can make one-off changes to Shifts if needed. If you need to adjust the Requirements levels, you can do so on the Template Requirements or Weekly Requirements pages. This page also shows historically which Shifts were performed, and who worked them. You will be able to see which Staff Events were attached to the historical Shifts. Red means underfulfilled, Orange means overfulfilled, and Green means perfect fulfilment. Yellow means the shift is Unassigned.
          </p>
        )

      case "weekly shifts by Person":
        return (
          <p>
            This shows the Weekly Shifts from a staff member perspective, giving you a quick view of who is working which hours. It synchronises with the Weekly Shifts by Role but does not detail whether the Weekly Requirement levels have been met or not, so if changes are made here then it is important to revisit the Weekly Shifts by Role page to check the levels.
          </p>
        )
    }
  }

  render() {
    let dynamicPart

    if (this.props.rota_id !== undefined) {
      dynamicPart = `${this.props.location_id}/rotas/${this.props.rota_id}`
    }
    else {
      dynamicPart = `${this.props.location_id}`
    }

    const currentSchedule = this.props.schedule
    const currentCoverage = this.props.coverage
    const currentView = this.props.view ? `by ${capitalize(this.props.view)}` : ""

    return (
      <>
        <div id="staff-fulfilment-flow">
          <div id="flow-container">
            <h4 className="flow-title">Current page</h4>

            <div className="page-toggle">
              <Link to={`/staff-fulfilment/${dynamicPart}/template/${currentCoverage}`} className={this.currentPage("schedule", "template")}>Template</Link>
              <Link to={`/staff-fulfilment/${dynamicPart}/weekly/${currentCoverage}`} className={this.currentPage("schedule", "weekly")}>Weekly</Link>
            </div>

            <div className="page-toggle">
              <Link to={`/staff-fulfilment/${dynamicPart}/${currentSchedule}/requirements`} className={this.currentPage("coverage", "requirements")}>Requirements</Link>
              <Link to={`/staff-fulfilment/${dynamicPart}/${currentSchedule}/shifts`} className={this.currentPage("coverage", "shifts")}>Shifts</Link>
            </div>

            {currentSchedule === "weekly" && currentCoverage === "shifts" ? (
              <div className="padding-top">
                <div className="page-toggle">
                  <Link to={`/staff-fulfilment/${dynamicPart}/weekly/shifts-by-role`} className={this.currentPage("view", "role")}>By Role</Link>
                  <Link to={`/staff-fulfilment/${dynamicPart}/weekly/shifts-by-person`} className={this.currentPage("view", "person")}>By Person</Link>
                </div>
              </div>
            ) : null}
          </div>
        </div>

        <div id="staff-filfilment-help-text">
          <h3>{`${capitalize(currentSchedule)} ${capitalize(currentCoverage)} ${currentView}`}</h3>
          {this.renderHelpText(currentSchedule, currentCoverage, currentView)}
        </div>
      </>
    );
  }
}

export default StafFulfilmentFlow;
